import React from 'react';
import './footer.scss';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Twitter from './../../img/icons/footer_twitter.svg';
import Telegram from './../../img/icons/footer_telegram.svg';
import Discord from './../../img/icons/footer_discord.svg';
import Whitepaper from './../../img/icons/footer_whitepaper.svg';
import Economy from './../../img/icons/footer_economy.svg';
const Footer = () => {
  return (
    <div className="App_footer">
      <Container maxWidth="xl">
        <ul>
          <li>
            <Button
              target="_blank"
              href="https://twitter.com/itrustfinance?lang=en"
            >
              <img alt="iTrust on Twitter" src={Twitter} />
              Twitter
            </Button>
          </li>
        </ul>

        <ul>
          <li>
            <Button target="_blank" href="https://discord.gg/pTre3yYu78">
              <img alt="iTrust on Discord" src={Discord} />
              Discord
            </Button>
          </li>
        </ul>

        <ul>
          <li>
            <Button target="_blank" href="https://t.me/iTrustCommunity">
              <img alt="iTrust on Telegram" src={Telegram} />
              Telegram
            </Button>
          </li>
        </ul>
        
      </Container>
    </div>
  );
};

export default Footer;
